import Cookies from 'js-cookie'

const app = {
  state: {
    globalSidebar: {
      opened: !+Cookies.get('globalSidebarStatus'),
      withoutAnimation: false
    },
    sidebar: {
      opened: !+Cookies.get('sidebarStatus'),
      withoutAnimation: false
    },
    signInPopup: {
      opened: false,
      subscribe: false
    },
    device: 'desktop',
    burgerAllowed: true,
    branchSelected: null,
    colorMode: +Cookies.get('colorMode'),
    colorTheme: Cookies.get('colorTheme'),
    lightThemeVariables: {},
    darkThemeVariables: {},
    darkBlueThemeVariables: {}
  },
  getters: {
    globalSidebar: state => state.globalSidebar,
    sidebar: state => state.sidebar,
    signInPopup: state => state.signInPopup,
    device: state => state.device,
    burgerAllowed: state => state.burgerAllowed,
    branchSelected: state => state.branchSelected,
    colorMode: state => state.colorMode,
    colorTheme: state => state.colorTheme,
    lightThemeVariables: state => state.lightThemeVariables,
    darkThemeVariables: state => state.darkThemeVariables,
    darkBlueThemeVariables: state => state.darkBlueThemeVariables
  },
  mutations: {
    TOGGLE_SIDEBAR: state => {
      if (state.sidebar.opened) {
        Cookies.set('sidebarStatus', 1)
      } else {
        Cookies.set('sidebarStatus', 0)
      }
      state.sidebar.opened = !state.sidebar.opened
      state.sidebar.withoutAnimation = false
    },
    CLOSE_SIDEBAR: (state, withoutAnimation) => {
      Cookies.set('sidebarStatus', 1)
      state.sidebar.opened = false
      state.sidebar.withoutAnimation = withoutAnimation
    },
    TOGGLE_GLOBAL_SIDEBAR: state => {
      if (state.globalSidebar.opened) {
        Cookies.set('globalSidebarStatus', 1)
      } else {
        Cookies.set('globalSidebarStatus', 0)
      }
      state.globalSidebar.opened = !state.globalSidebar.opened
      state.globalSidebar.withoutAnimation = false
    },
    CLOSE_GLOBAL_SIDEBAR: (state, withoutAnimation) => {
      Cookies.set('globalSidebarStatus', 1)
      state.globalSidebar.opened = false
      state.globalSidebar.withoutAnimation = withoutAnimation
    },
    OPEN_SIGN_IN_POPUP: (state, subscribe) => {
      state.signInPopup.opened = true
      state.signInPopup.subscribe = subscribe
    },
    CLOSE_SIGN_IN_POPUP: state => {
      state.signInPopup.opened = false
      state.signInPopup.subscribe = false
    },
    TOGGLE_DEVICE: (state, device) => {
      state.device = device
    },
    ENABLE_BURGER_ALLOWED: state => {
      state.burgerAllowed = true
    },
    DISABLE_BURGER_ALLOWED: state => {
      state.burgerAllowed = false
    },
    SET_BRANCH_SELECTED: (state, branch) => {
      Cookies.set('branchSelected', branch)
      state.branchSelected = branch
    },
    TOGGLE_COLOR_MODE: (state) => {
      if (!state.colorMode) {
        Cookies.set('colorMode', 1)
      } else {
        Cookies.set('colorMode', 0)
      }
      state.colorMode = !state.colorMode
    },
    SET_COLOR_MODE: (state, colorMode) => {
      Cookies.set('colorMode', colorMode)
      state.colorMode = colorMode
    },
    TOGGLE_COLOR_THEME: (state, tempColorTheme) => {
      Cookies.set('colorTheme', tempColorTheme)
      state.colorTheme = tempColorTheme
      console.log('colorTheme', state.colorTheme)
    },
    SET_LIGHT_THEME_VARIABLES: (state, lightThemeVariables) => {
      state.lightThemeVariables = lightThemeVariables
    },
    SET_DARK_THEME_VARIABLES: (state, darkThemeVariables) => {
      state.darkThemeVariables = darkThemeVariables
    },
    SET_DARK_BLUE_THEME_VARIABLES: (state, darkBlueThemeVariables) => {
      state.darkBlueThemeVariables = darkBlueThemeVariables
    },
    APPLY_THEME_VARIABLES: (state, theme) => {
      let variables = []
      switch (theme) {
        case 'light':
          variables = state.lightThemeVariables
          break
        case 'dark':
          variables = state.darkThemeVariables
          break
        case 'darkblue':
          variables = state.darkBlueThemeVariables
          break
      }
      const keys = Object.keys(variables)
      keys.forEach(key => {
        document.documentElement.style.setProperty(key, variables[key])
      })
    }
  },
  actions: {
    ToggleSideBar: ({ commit }) => {
      commit('TOGGLE_SIDEBAR')
    },
    CloseSideBar({ commit }, { withoutAnimation }) {
      commit('CLOSE_SIDEBAR', withoutAnimation)
    },
    ToggleGlobalSideBar: ({ commit }) => {
      commit('TOGGLE_GLOBAL_SIDEBAR')
    },
    CloseGlobalSideBar({ commit }, { withoutAnimation }) {
      commit('CLOSE_GLOBAL_SIDEBAR', withoutAnimation)
    },
    OpenSignInPopup({ commit }, { subscribe }) {
      commit('OPEN_SIGN_IN_POPUP', subscribe)
    },
    CloseSignInPopup({ commit }) {
      commit('CLOSE_SIGN_IN_POPUP')
    },
    ToggleDevice({ commit }, device) {
      commit('TOGGLE_DEVICE', device)
    },
    EnableBurgerAllowed({ commit }) {
      commit('ENABLE_BURGER_ALLOWED')
    },
    DisableBurgerAllowed({ commit }) {
      commit('DISABLE_BURGER_ALLOWED')
    },
    SetBranchSelected({ commit }, branch) {
      commit('SET_BRANCH_SELECTED', branch)
    },
    ToggleColorMode({ commit }) {
      commit('TOGGLE_COLOR_MODE')
    },
    SetColorMode({ commit }, colorMode) {
      commit('SET_COLOR_MODE', colorMode)
    },
    ToggleColorTheme({ commit }, tempColorTheme) {
      commit('TOGGLE_COLOR_THEME', tempColorTheme)
      commit('APPLY_THEME_VARIABLES', tempColorTheme)
    },
    SetLightThemeVariables({ commit }, lightThemeVariables) {
      commit('SET_LIGHT_THEME_VARIABLES', lightThemeVariables)
    },
    SetDarkThemeVariables({ commit }, darkThemeVariables) {
      commit('SET_DARK_THEME_VARIABLES', darkThemeVariables)
    },
    SetDarkBlueThemeVariables({ commit }, darkBlueThemeVariables) {
      commit('SET_DARK_BLUE_THEME_VARIABLES', darkBlueThemeVariables)
    },
    SetThemeVariables({ commit, state }, themeVariables) {
      const lightThemeVariables = themeVariables.lightThemeVariables
      const darkThemeVariables = themeVariables.darkThemeVariables
      const darkBlueThemeVariables = themeVariables.darkBlueThemeVariables
      commit('SET_LIGHT_THEME_VARIABLES', lightThemeVariables)
      commit('SET_DARK_THEME_VARIABLES', darkThemeVariables)
      commit('SET_DARK_BLUE_THEME_VARIABLES', darkBlueThemeVariables)
      commit('APPLY_THEME_VARIABLES', state.colorTheme)
    },
    ApplyThemeVariables({ commit }, theme) {
      commit('APPLY_THEME_VARIABLES', theme)
    },
  }
}

export default app



// WEBPACK FOOTER //
// ./src/store/modules/app.js